export type CableCause = {
  cause: string;
  probability: number;
};

export type CableFault = {
  id: string;
  category_id: string | null;
  device_ar: string;
  name_ar: string;
  description_ar: string;
  symptoms: string[];
  causes: CableCause[];
  tests: {
    test: string;
    location: string;
    method: string;
    normal: string;
    faulty: string;
  }[];
  solutions: string[];
  severity: string;
  safety_warnings: string[];
  error_code: string | null;
  keywords: string;
  next_question_key: string | null;
};

type Row = [
  string,
  string,
  string,
  string,
  string,
  CableCause[],
  string[],
  string,
  string
];

const C = (cause: string, probability: number): CableCause => ({
  cause,
  probability,
});

const rows: Row[] = [
[
  "cable-001",
  "كيبل القدرة الرئيسي",
  "كيبل القدرة الرئيسي ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة كيبل القدرة الرئيسي متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة كيبل القدرة الرئيسي",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الكابلات والأسلاك main power cable not working open",
],
[
  "cable-002",
  "كيبل القدرة الرئيسي",
  "حرارة كيبل القدرة الرئيسي ترتفع",
  "حرارة كيبل القدرة الرئيسي أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة كيبل القدرة الرئيسي",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الكابلات والأسلاك main power cable overheating hot",
],
[
  "cable-003",
  "كيبل القدرة الرئيسي",
  "كيبل القدرة الرئيسي يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة كيبل القدرة الرئيسي تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الكابلات والأسلاك main power cable intermittent unstable",
],
[
  "cable-004",
  "كيبل القدرة الرئيسي",
  "كيبل القدرة الرئيسي بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ كيبل القدرة الرئيسي.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الكابلات والأسلاك main power cable loose wrong connection",
],
[
  "cable-005",
  "كيبل القدرة الرئيسي",
  "قراءة أو خرج كيبل القدرة الرئيسي مو طبيعي",
  "قراءة أو خرج كيبل القدرة الرئيسي أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الكابلات والأسلاك main power cable abnormal reading output",
],
[
  "cable-006",
  "كيبل المحرك",
  "كيبل المحرك ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة كيبل المحرك متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة كيبل المحرك",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الكابلات والأسلاك motor cable not working open",
],
[
  "cable-007",
  "كيبل المحرك",
  "حرارة كيبل المحرك ترتفع",
  "حرارة كيبل المحرك أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة كيبل المحرك",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الكابلات والأسلاك motor cable overheating hot",
],
[
  "cable-008",
  "كيبل المحرك",
  "كيبل المحرك يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة كيبل المحرك تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الكابلات والأسلاك motor cable intermittent unstable",
],
[
  "cable-009",
  "كيبل المحرك",
  "كيبل المحرك بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ كيبل المحرك.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الكابلات والأسلاك motor cable loose wrong connection",
],
[
  "cable-010",
  "كيبل المحرك",
  "قراءة أو خرج كيبل المحرك مو طبيعي",
  "قراءة أو خرج كيبل المحرك أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الكابلات والأسلاك motor cable abnormal reading output",
],
[
  "cable-011",
  "كيبل VFD",
  "كيبل VFD ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة كيبل VFD متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة كيبل VFD",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الكابلات والأسلاك vfd cable not working open",
],
[
  "cable-012",
  "كيبل VFD",
  "حرارة كيبل VFD ترتفع",
  "حرارة كيبل VFD أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة كيبل VFD",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الكابلات والأسلاك vfd cable overheating hot",
],
[
  "cable-013",
  "كيبل VFD",
  "كيبل VFD يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة كيبل VFD تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الكابلات والأسلاك vfd cable intermittent unstable",
],
[
  "cable-014",
  "كيبل VFD",
  "كيبل VFD بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ كيبل VFD.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الكابلات والأسلاك vfd cable loose wrong connection",
],
[
  "cable-015",
  "كيبل VFD",
  "قراءة أو خرج كيبل VFD مو طبيعي",
  "قراءة أو خرج كيبل VFD أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الكابلات والأسلاك vfd cable abnormal reading output",
],
[
  "cable-016",
  "كيبل السيطرة",
  "كيبل السيطرة ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة كيبل السيطرة متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة كيبل السيطرة",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الكابلات والأسلاك control cable not working open",
],
[
  "cable-017",
  "كيبل السيطرة",
  "حرارة كيبل السيطرة ترتفع",
  "حرارة كيبل السيطرة أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة كيبل السيطرة",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الكابلات والأسلاك control cable overheating hot",
],
[
  "cable-018",
  "كيبل السيطرة",
  "كيبل السيطرة يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة كيبل السيطرة تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الكابلات والأسلاك control cable intermittent unstable",
],
[
  "cable-019",
  "كيبل السيطرة",
  "كيبل السيطرة بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ كيبل السيطرة.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الكابلات والأسلاك control cable loose wrong connection",
],
[
  "cable-020",
  "كيبل السيطرة",
  "قراءة أو خرج كيبل السيطرة مو طبيعي",
  "قراءة أو خرج كيبل السيطرة أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الكابلات والأسلاك control cable abnormal reading output",
],
[
  "cable-021",
  "كيبل Analog",
  "كيبل Analog ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة كيبل Analog متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة كيبل Analog",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الكابلات والأسلاك analog cable not working open",
],
[
  "cable-022",
  "كيبل Analog",
  "حرارة كيبل Analog ترتفع",
  "حرارة كيبل Analog أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة كيبل Analog",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الكابلات والأسلاك analog cable overheating hot",
],
[
  "cable-023",
  "كيبل Analog",
  "كيبل Analog يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة كيبل Analog تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الكابلات والأسلاك analog cable intermittent unstable",
],
[
  "cable-024",
  "كيبل Analog",
  "كيبل Analog بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ كيبل Analog.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الكابلات والأسلاك analog cable loose wrong connection",
],
[
  "cable-025",
  "كيبل Analog",
  "قراءة أو خرج كيبل Analog مو طبيعي",
  "قراءة أو خرج كيبل Analog أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الكابلات والأسلاك analog cable abnormal reading output",
],
[
  "cable-026",
  "كيبل 4-20mA",
  "كيبل 4-20mA ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة كيبل 4-20mA متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة كيبل 4-20mA",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الكابلات والأسلاك 4-20ma cable not working open",
],
[
  "cable-027",
  "كيبل 4-20mA",
  "حرارة كيبل 4-20mA ترتفع",
  "حرارة كيبل 4-20mA أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة كيبل 4-20mA",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الكابلات والأسلاك 4-20ma cable overheating hot",
],
[
  "cable-028",
  "كيبل 4-20mA",
  "كيبل 4-20mA يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة كيبل 4-20mA تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الكابلات والأسلاك 4-20ma cable intermittent unstable",
],
[
  "cable-029",
  "كيبل 4-20mA",
  "كيبل 4-20mA بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ كيبل 4-20mA.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الكابلات والأسلاك 4-20ma cable loose wrong connection",
],
[
  "cable-030",
  "كيبل 4-20mA",
  "قراءة أو خرج كيبل 4-20mA مو طبيعي",
  "قراءة أو خرج كيبل 4-20mA أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الكابلات والأسلاك 4-20ma cable abnormal reading output",
],
[
  "cable-031",
  "كيبل Encoder",
  "كيبل Encoder ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة كيبل Encoder متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة كيبل Encoder",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الكابلات والأسلاك encoder cable not working open",
],
[
  "cable-032",
  "كيبل Encoder",
  "حرارة كيبل Encoder ترتفع",
  "حرارة كيبل Encoder أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة كيبل Encoder",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الكابلات والأسلاك encoder cable overheating hot",
],
[
  "cable-033",
  "كيبل Encoder",
  "كيبل Encoder يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة كيبل Encoder تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الكابلات والأسلاك encoder cable intermittent unstable",
],
[
  "cable-034",
  "كيبل Encoder",
  "كيبل Encoder بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ كيبل Encoder.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الكابلات والأسلاك encoder cable loose wrong connection",
],
[
  "cable-035",
  "كيبل Encoder",
  "قراءة أو خرج كيبل Encoder مو طبيعي",
  "قراءة أو خرج كيبل Encoder أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الكابلات والأسلاك encoder cable abnormal reading output",
],
[
  "cable-036",
  "كيبل الشبكة الصناعية",
  "كيبل الشبكة الصناعية ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة كيبل الشبكة الصناعية متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة كيبل الشبكة الصناعية",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الكابلات والأسلاك fieldbus cable not working open",
],
[
  "cable-037",
  "كيبل الشبكة الصناعية",
  "حرارة كيبل الشبكة الصناعية ترتفع",
  "حرارة كيبل الشبكة الصناعية أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة كيبل الشبكة الصناعية",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الكابلات والأسلاك fieldbus cable overheating hot",
],
[
  "cable-038",
  "كيبل الشبكة الصناعية",
  "كيبل الشبكة الصناعية يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة كيبل الشبكة الصناعية تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الكابلات والأسلاك fieldbus cable intermittent unstable",
],
[
  "cable-039",
  "كيبل الشبكة الصناعية",
  "كيبل الشبكة الصناعية بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ كيبل الشبكة الصناعية.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الكابلات والأسلاك fieldbus cable loose wrong connection",
],
[
  "cable-040",
  "كيبل الشبكة الصناعية",
  "قراءة أو خرج كيبل الشبكة الصناعية مو طبيعي",
  "قراءة أو خرج كيبل الشبكة الصناعية أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الكابلات والأسلاك fieldbus cable abnormal reading output",
],
[
  "cable-041",
  "كيبل PE",
  "كيبل PE ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة كيبل PE متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة كيبل PE",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الكابلات والأسلاك ground cable not working open",
],
[
  "cable-042",
  "كيبل PE",
  "حرارة كيبل PE ترتفع",
  "حرارة كيبل PE أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة كيبل PE",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الكابلات والأسلاك ground cable overheating hot",
],
[
  "cable-043",
  "كيبل PE",
  "كيبل PE يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة كيبل PE تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الكابلات والأسلاك ground cable intermittent unstable",
],
[
  "cable-044",
  "كيبل PE",
  "كيبل PE بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ كيبل PE.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الكابلات والأسلاك ground cable loose wrong connection",
],
[
  "cable-045",
  "كيبل PE",
  "قراءة أو خرج كيبل PE مو طبيعي",
  "قراءة أو خرج كيبل PE أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الكابلات والأسلاك ground cable abnormal reading output",
],
[
  "cable-046",
  "كيبل DC",
  "كيبل DC ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة كيبل DC متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة كيبل DC",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الكابلات والأسلاك dc cable not working open",
],
[
  "cable-047",
  "كيبل DC",
  "حرارة كيبل DC ترتفع",
  "حرارة كيبل DC أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة كيبل DC",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الكابلات والأسلاك dc cable overheating hot",
],
[
  "cable-048",
  "كيبل DC",
  "كيبل DC يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة كيبل DC تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الكابلات والأسلاك dc cable intermittent unstable",
],
[
  "cable-049",
  "كيبل DC",
  "كيبل DC بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ كيبل DC.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الكابلات والأسلاك dc cable loose wrong connection",
],
[
  "cable-050",
  "كيبل DC",
  "قراءة أو خرج كيبل DC مو طبيعي",
  "قراءة أو خرج كيبل DC أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الكابلات والأسلاك dc cable abnormal reading output",
],
[
  "cable-051",
  "كيبل البطارية",
  "كيبل البطارية ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة كيبل البطارية متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة كيبل البطارية",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الكابلات والأسلاك battery cable not working open",
],
[
  "cable-052",
  "كيبل البطارية",
  "حرارة كيبل البطارية ترتفع",
  "حرارة كيبل البطارية أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة كيبل البطارية",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الكابلات والأسلاك battery cable overheating hot",
],
[
  "cable-053",
  "كيبل البطارية",
  "كيبل البطارية يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة كيبل البطارية تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الكابلات والأسلاك battery cable intermittent unstable",
],
[
  "cable-054",
  "كيبل البطارية",
  "كيبل البطارية بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ كيبل البطارية.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الكابلات والأسلاك battery cable loose wrong connection",
],
[
  "cable-055",
  "كيبل البطارية",
  "قراءة أو خرج كيبل البطارية مو طبيعي",
  "قراءة أو خرج كيبل البطارية أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الكابلات والأسلاك battery cable abnormal reading output",
],
[
  "cable-056",
  "كيبل PV",
  "كيبل PV ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة كيبل PV متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة كيبل PV",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الكابلات والأسلاك solar pv cable not working open",
],
[
  "cable-057",
  "كيبل PV",
  "حرارة كيبل PV ترتفع",
  "حرارة كيبل PV أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة كيبل PV",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الكابلات والأسلاك solar pv cable overheating hot",
],
[
  "cable-058",
  "كيبل PV",
  "كيبل PV يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة كيبل PV تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الكابلات والأسلاك solar pv cable intermittent unstable",
],
[
  "cable-059",
  "كيبل PV",
  "كيبل PV بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ كيبل PV.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الكابلات والأسلاك solar pv cable loose wrong connection",
],
[
  "cable-060",
  "كيبل PV",
  "قراءة أو خرج كيبل PV مو طبيعي",
  "قراءة أو خرج كيبل PV أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الكابلات والأسلاك solar pv cable abnormal reading output",
],
[
  "cable-061",
  "Cable Gland",
  "Cable Gland ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Cable Gland متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Cable Gland",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الكابلات والأسلاك cable gland not working open",
],
[
  "cable-062",
  "Cable Gland",
  "حرارة Cable Gland ترتفع",
  "حرارة Cable Gland أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Cable Gland",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الكابلات والأسلاك cable gland overheating hot",
],
[
  "cable-063",
  "Cable Gland",
  "Cable Gland يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Cable Gland تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الكابلات والأسلاك cable gland intermittent unstable",
],
[
  "cable-064",
  "Cable Gland",
  "Cable Gland بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Cable Gland.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الكابلات والأسلاك cable gland loose wrong connection",
],
[
  "cable-065",
  "Cable Gland",
  "قراءة أو خرج Cable Gland مو طبيعي",
  "قراءة أو خرج Cable Gland أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الكابلات والأسلاك cable gland abnormal reading output",
],
[
  "cable-066",
  "Cable Lug",
  "Cable Lug ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Cable Lug متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Cable Lug",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الكابلات والأسلاك cable lug not working open",
],
[
  "cable-067",
  "Cable Lug",
  "حرارة Cable Lug ترتفع",
  "حرارة Cable Lug أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Cable Lug",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الكابلات والأسلاك cable lug overheating hot",
],
[
  "cable-068",
  "Cable Lug",
  "Cable Lug يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Cable Lug تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الكابلات والأسلاك cable lug intermittent unstable",
],
[
  "cable-069",
  "Cable Lug",
  "Cable Lug بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Cable Lug.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الكابلات والأسلاك cable lug loose wrong connection",
],
[
  "cable-070",
  "Cable Lug",
  "قراءة أو خرج Cable Lug مو طبيعي",
  "قراءة أو خرج Cable Lug أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الكابلات والأسلاك cable lug abnormal reading output",
],
[
  "cable-071",
  "Ferrule",
  "Ferrule ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Ferrule متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Ferrule",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الكابلات والأسلاك ferrule not working open",
],
[
  "cable-072",
  "Ferrule",
  "حرارة Ferrule ترتفع",
  "حرارة Ferrule أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Ferrule",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الكابلات والأسلاك ferrule overheating hot",
],
[
  "cable-073",
  "Ferrule",
  "Ferrule يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Ferrule تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الكابلات والأسلاك ferrule intermittent unstable",
],
[
  "cable-074",
  "Ferrule",
  "Ferrule بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Ferrule.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الكابلات والأسلاك ferrule loose wrong connection",
],
[
  "cable-075",
  "Ferrule",
  "قراءة أو خرج Ferrule مو طبيعي",
  "قراءة أو خرج Ferrule أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الكابلات والأسلاك ferrule abnormal reading output",
],
[
  "cable-076",
  "Cable Tray",
  "Cable Tray ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Cable Tray متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Cable Tray",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الكابلات والأسلاك cable tray not working open",
],
[
  "cable-077",
  "Cable Tray",
  "حرارة Cable Tray ترتفع",
  "حرارة Cable Tray أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Cable Tray",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الكابلات والأسلاك cable tray overheating hot",
],
[
  "cable-078",
  "Cable Tray",
  "Cable Tray يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Cable Tray تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الكابلات والأسلاك cable tray intermittent unstable",
],
[
  "cable-079",
  "Cable Tray",
  "Cable Tray بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Cable Tray.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الكابلات والأسلاك cable tray loose wrong connection",
],
[
  "cable-080",
  "Cable Tray",
  "قراءة أو خرج Cable Tray مو طبيعي",
  "قراءة أو خرج Cable Tray أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الكابلات والأسلاك cable tray abnormal reading output",
],
[
  "cable-081",
  "Conduit",
  "Conduit ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Conduit متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Conduit",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الكابلات والأسلاك conduit not working open",
],
[
  "cable-082",
  "Conduit",
  "حرارة Conduit ترتفع",
  "حرارة Conduit أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Conduit",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الكابلات والأسلاك conduit overheating hot",
],
[
  "cable-083",
  "Conduit",
  "Conduit يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Conduit تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الكابلات والأسلاك conduit intermittent unstable",
],
[
  "cable-084",
  "Conduit",
  "Conduit بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Conduit.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الكابلات والأسلاك conduit loose wrong connection",
],
[
  "cable-085",
  "Conduit",
  "قراءة أو خرج Conduit مو طبيعي",
  "قراءة أو خرج Conduit أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الكابلات والأسلاك conduit abnormal reading output",
],
[
  "cable-086",
  "Cable Joint",
  "Cable Joint ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Cable Joint متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Cable Joint",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الكابلات والأسلاك cable joint not working open",
],
[
  "cable-087",
  "Cable Joint",
  "حرارة Cable Joint ترتفع",
  "حرارة Cable Joint أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Cable Joint",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الكابلات والأسلاك cable joint overheating hot",
],
[
  "cable-088",
  "Cable Joint",
  "Cable Joint يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Cable Joint تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الكابلات والأسلاك cable joint intermittent unstable",
],
[
  "cable-089",
  "Cable Joint",
  "Cable Joint بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Cable Joint.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الكابلات والأسلاك cable joint loose wrong connection",
],
[
  "cable-090",
  "Cable Joint",
  "قراءة أو خرج Cable Joint مو طبيعي",
  "قراءة أو خرج Cable Joint أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الكابلات والأسلاك cable joint abnormal reading output",
],
[
  "cable-091",
  "Cable Termination",
  "Cable Termination ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Cable Termination متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Cable Termination",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الكابلات والأسلاك cable termination not working open",
],
[
  "cable-092",
  "Cable Termination",
  "حرارة Cable Termination ترتفع",
  "حرارة Cable Termination أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Cable Termination",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الكابلات والأسلاك cable termination overheating hot",
],
[
  "cable-093",
  "Cable Termination",
  "Cable Termination يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Cable Termination تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الكابلات والأسلاك cable termination intermittent unstable",
],
[
  "cable-094",
  "Cable Termination",
  "Cable Termination بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Cable Termination.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الكابلات والأسلاك cable termination loose wrong connection",
],
[
  "cable-095",
  "Cable Termination",
  "قراءة أو خرج Cable Termination مو طبيعي",
  "قراءة أو خرج Cable Termination أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الكابلات والأسلاك cable termination abnormal reading output",
],
[
  "cable-096",
  "عازل الكيبل",
  "عازل الكيبل ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة عازل الكيبل متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة عازل الكيبل",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الكابلات والأسلاك cable insulation not working open",
],
[
  "cable-097",
  "عازل الكيبل",
  "حرارة عازل الكيبل ترتفع",
  "حرارة عازل الكيبل أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة عازل الكيبل",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الكابلات والأسلاك cable insulation overheating hot",
],
[
  "cable-098",
  "عازل الكيبل",
  "عازل الكيبل يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة عازل الكيبل تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الكابلات والأسلاك cable insulation intermittent unstable",
],
[
  "cable-099",
  "عازل الكيبل",
  "عازل الكيبل بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ عازل الكيبل.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الكابلات والأسلاك cable insulation loose wrong connection",
],
[
  "cable-100",
  "عازل الكيبل",
  "قراءة أو خرج عازل الكيبل مو طبيعي",
  "قراءة أو خرج عازل الكيبل أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("مقطع الكيبل أو نوعه مو مناسب", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الكابلات والأسلاك cable insulation abnormal reading output",
],
];

export const cableFaults: CableFault[] = rows.map(
  ([
    id,
    device_ar,
    name_ar,
    description_ar,
    symptom,
    causes,
    solutions,
    severity,
    keywords,
  ]) => {
    const critical = severity === "حرجة";

    return {
      id,
      category_id: null,
      device_ar,
      name_ar,
      description_ar,
      symptoms: [symptom],
      causes,
      tests: [
        {
          test: "الفحص الأولي",
          location: device_ar,
          method: "افصل وعزل الدائرة قبل فحص الاستمرارية أو العزل. لا تستخدم Megger على VFD أو PLC أو أجهزة إلكترونية وهي مربوطة بالكيبل؛ افصلها حسب تعليمات المصنع أولاً.",
          normal:
            "القراءات والحرارة والتوصيلات ضمن الطبيعي، وماكو حرك أو تسريب أو تقطيع أو تلف واضح.",
          faulty:
            "حرارة عالية أو فصل متكرر أو ربط مرخي أو قراءة غير طبيعية يدل على عطل يحتاج فحص قبل التشغيل.",
        },
      ],
      solutions,
      severity,
      safety_warnings: critical
        ? [
            "تنبيه: اعزل كل مصادر الطاقة قبل الصيانة وانتبه من التغذية الراجعة أو التشغيل الأوتوماتيكي.",
            "العمل أو القياس على أجزاء حية أو جهد عالي خليه لفني مؤهل وبمعدات مناسبة.",
          ]
        : [
            "افصل وعزل التغذية قبل الفك أو إعادة الربط.",
            "إذا شفت شرر أو ذوبان أو ريحة حرك أو تشغيل غير متوقع، وقف المعدة وخلي فني يفحصها.",
          ],
      error_code: null,
      keywords,
      next_question_key: null,
    };
  },
);
